type MewsAPI = {
  setLanguageCode: (lang: string) => void;
  setCurrencyCode: (code: string) => void;
  setStartDate: (date: Date) => void;
  setEndDate: (date: Date) => void;
  setAdultCount: (n: number) => void;
  showRooms: (configurationId: string) => void;
  showRates: (resourceId: string) => void;
  open: () => void;
};

declare global {
  interface Window {
    Mews?: any;
  }
}

const MEWS_SCRIPT = "https://api.mews.com/distributor/distributor.min.js";
// Your hotel configurationIds (from Mews). You already shared Döttingen:
const HOTEL_CONFIG_IDS: Record<string, string> = {
  dottingen: "5ce23cfa-59c9-41c5-8da4-b0ff00945dda",
  // littau: "<your-littau-configuration-id>",
};

let apiPromise: Promise<MewsAPI> | null = null;

function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve();
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Failed to load Mews script"));
    document.head.appendChild(s);
  });
}

export async function getMews(): Promise<MewsAPI> {
  if (apiPromise) return apiPromise;

  apiPromise = (async () => {
    await loadScript(MEWS_SCRIPT);

    // Wait for window.Mews to be ready
    await new Promise<void>((res) => {
      const tick = () =>
        window.Mews?.Distributor ? res() : setTimeout(tick, 30);
      tick();
    });

    // Initialize ONE distributor instance for all hotels you support
    return new Promise<MewsAPI>((resolve) => {
      window.Mews!.Distributor(
        {
          configurationIds: Object.values(HOTEL_CONFIG_IDS),
        },
        (api: MewsAPI) => {
          // Optional defaults:
          try {
            const lang = document.documentElement.lang || "en";
            api.setLanguageCode(lang);
          } catch {}
          resolve(api);
        },
        { dataBaseUrl: "https://api.mews.com" },
      );
    });
  })();

  return apiPromise;
}

export function getHotelConfigurationId(uiHotelId: string): string | undefined {
  return HOTEL_CONFIG_IDS[uiHotelId];
}
